var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('ColumnLayout',{scopedSlots:_vm._u([{key:"sidebar",fn:function(){return [_vm._v(" Sidebar content ")]},proxy:true},{key:"main",fn:function(){return undefined},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }